<script>
    import ClearButton from "./ClearButton.svelte"

    export let name
    export let birthday
    export let birthdayUnits

    console.log("Initializing PersonDataInput")

    $: console.log("name changed to", name)
    $: console.log("birthday changed to", birthday)

    console.log("PersonDataInput initialized")
</script>

<style>
    input {
        display: block;
    }

    input:last-of-type {
        margin-bottom: 1rem;
    }
</style>

<label for="name">Name</label>
<input name="name" type="text" bind:value={name} />

{#each birthdayUnits as unit}
    <label for={unit}>{unit}</label>
    <input name={unit} type="number" bind:value={birthday[unit]} />
{/each}

<ClearButton
    on:clear={event => {
        birthdayUnits.forEach(unit => (birthday[unit] = null))
        name = null
    }} />
